/* =========================================================================
   GRACES COLLECTION — global.js
   ========================================================================= */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function money(cents) {
    var fmt = (window.GC && window.GC.money) || '£{{amount}}';
    var amt = (Math.round(cents) / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt.replace('.', ','));
  }

  /* ---------- Drawers + overlay ---------- */
  var overlay = $('[data-overlay]');
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('[data-drawer-close], a, button'); if (f) f.focus();
  }
  function closeDrawers() {
    $$('[data-drawer]').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 400); }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) { closeDrawers(); closeModals(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeModals(); } });

  /* ---------- Mobile nav accordion ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-accordion]'); if (!t) return;
    e.preventDefault(); var row = t.closest('.m-nav__row'); if (row) row.classList.toggle('is-open');
  });

  /* ---------- Modals ---------- */
  function openModal(name) {
    var m = $('[data-modal="' + name + '"]'); if (!m) return;
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
  }
  function closeModals() { $$('[data-modal]').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]'); if (o) { e.preventDefault(); openModal(o.getAttribute('data-modal-open')); }
    if (e.target.closest('[data-modal-close]')) closeModals();
  });

  /* ---------- Cart: AJAX add + drawer refresh ---------- */
  function updateCount(count) { $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count < 1; }); }
  function refreshCartDrawer() {
    return fetch(ROOT + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#CartDrawer'), curr = $('#CartDrawer');
        if (next && curr) curr.replaceWith(next);
        var badge = doc.querySelector('[data-cart-total-count]');
        if (badge) updateCount(parseInt(badge.getAttribute('data-cart-total-count'), 10) || 0);
      });
  }
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Adding…'; }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (!res.ok) throw res.j; return refreshCartDrawer(); })
      .then(function () { openDrawer('cart'); })
      .catch(function (err) { var m = form.querySelector('[data-form-error]'); if (m) m.textContent = (err && err.description) || 'Sorry, that could not be added.'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label || 'Add to bag'; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]'); if (form) { e.preventDefault(); addToCart(form); }
  });
  function changeLine(key, qty) {
    fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(refreshCartDrawer);
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-change]'); if (step) {
      var wrap = step.closest('[data-line]'); if (!wrap) return;
      var input = wrap.querySelector('input'); var q = parseInt(input.value, 10) || 1;
      q = step.getAttribute('data-qty-change') === 'up' ? q + 1 : Math.max(0, q - 1);
      input.value = q; changeLine(wrap.getAttribute('data-line'), q); return;
    }
    var rm = e.target.closest('[data-line-remove]'); if (rm) { e.preventDefault(); var w = rm.closest('[data-line]'); if (w) changeLine(w.getAttribute('data-line'), 0); }
  });
  /* Quick-add from product cards */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]'); if (!qa) return;
    e.preventDefault();
    var id = qa.getAttribute('data-quick-add'); if (!id) return;
    qa.classList.add('is-loading');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (!res.ok) throw res.j; return refreshCartDrawer(); })
      .then(function () { openDrawer('cart'); })
      .catch(function () {})
      .finally(function () { qa.classList.remove('is-loading'); });
  });

  /* ---------- PDP gallery carousel + lightbox ---------- */
  window.GC_galleries = [];
  $$('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    if (!track) return;
    var slides = $$('.pdpg__slide', track);
    var dots = $$('[data-dot]', g);
    function index() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function goTo(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function sync() { var i = index(); dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); }); }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    var canHover = window.matchMedia('(hover: hover)').matches;
    slides.forEach(function (slide) {
      var img = slide.querySelector('img'); if (!img) return;
      if (canHover) {
        slide.addEventListener('mousemove', function (e) {
          var r = img.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          img.style.transform = 'scale(2)';
        });
        slide.addEventListener('mouseleave', function () { img.style.transform = ''; });
      }
    });
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-next]')) { goTo(index() + 1); return; }
      if (e.target.closest('[data-prev]')) { goTo(index() - 1); return; }
      var dot = e.target.closest('[data-dot]'); if (dot) { goTo(parseInt(dot.getAttribute('data-dot'), 10)); return; }
      if (canHover) return;
      var slide = e.target.closest('[data-slide]');
      if (slide) {
        var img = slide.querySelector('img'); if (!img) return;
        if (img.style.transform) { img.style.transform = ''; }
        else { var r = img.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; img.style.transform = 'scale(2.2)'; }
      }
    });
    g.goToImageSrc = function (src) {
      if (!src) return false;
      var name = src.split('?')[0].split('/').pop();
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (im && im.getAttribute('src').split('?')[0].split('/').pop() === name) { goTo(i); return true; }
      }
      return false;
    };
    window.GC_galleries.push(g);
    sync();
  });

  /* ---------- PDP variant picker ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]'); if (!dataEl) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('[name="id"]');
    var groups = $$('[data-option-index]', form);

    function selected() {
      return groups.map(function (g) {
        var c = g.querySelector(':checked') || g.querySelector('[aria-pressed="true"]');
        return c ? (c.value || c.getAttribute('data-value')) : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) { return opts.every(function (o, i) { return o == null || v.options[i] === o; }); });
    }
    function setPrice(v) {
      var box = form.parentNode.querySelector('.buybox__price') || document.querySelector('.buybox__price');
      if (box) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          box.innerHTML = '<span class="now">' + money(v.price) + '</span><span class="was">' + money(v.compare_at_price) + '</span><span class="save">Save ' + pct + '%</span>';
        } else {
          box.innerHTML = '<span class="now now--reg">' + money(v.price) + '</span>';
        }
      }
      $$('[data-atc-price]').forEach(function (el) { el.textContent = money(v.price); });
      var inst = document.querySelector('[data-instal]'); if (inst) inst.textContent = money(v.price / 4);
    }
    function availabilityUpdate(sel) {
      groups.forEach(function (g, gi) {
        $$('.size,[data-swatch]', g).forEach(function (btn) {
          var val = btn.value || btn.getAttribute('data-value');
          var test = sel.slice(); test[gi] = val;
          var match = variants.find(function (v) { return test.every(function (o, i) { return o == null || v.options[i] === o; }); });
          var ok = match && match.available;
          if (btn.classList.contains('size')) { btn.disabled = !ok; }
        });
      });
    }
    function update() {
      var sel = selected();
      availabilityUpdate(sel);
      var v = findVariant(sel);
      var btn = form.querySelector('[type="submit"]');
      var colorName = form.querySelector('[data-opt-selected]');
      if (colorName) { groups.forEach(function (g) { var c = g.querySelector('[data-swatch][aria-pressed="true"]'); if (c) colorName.textContent = c.getAttribute('data-value'); }); }
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      setPrice(v);
      if (v.featured_image && v.featured_image.src && window.GC_galleries && window.GC_galleries[0]) {
        window.GC_galleries[0].goToImageSrc(v.featured_image.src);
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.dataset.add = 'Add to bag';
        btn.innerHTML = v.available ? ('Add to bag · <span data-atc-price>' + money(v.price) + '</span>') : 'Sold out';
      }
    }
    form.addEventListener('click', function (e) {
      var chip = e.target.closest('.size,[data-swatch]'); if (!chip || chip.disabled) return;
      var g = chip.closest('[data-option-index]'); if (!g) return;
      $$('.size,[data-swatch]', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      update();
    });
    /* quantity stepper */
    form.addEventListener('click', function (e) {
      var input = form.querySelector('[data-qty-input]'); if (!input) return;
      if (e.target.closest('[data-qty-inc]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      if (e.target.closest('[data-qty-dec]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    availabilityUpdate(selected());
  });

  /* Sticky mobile ATC */
  var mainAtc = $('.atc');
  var stickyAtc = $('[data-sticky-atc]');
  if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { stickyAtc.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(mainAtc);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sticky-add]')) { var f = $('[data-product-form]'); if (f) f.requestSubmit ? f.requestSubmit() : addToCart(f); }
  });

  /* Wishlist (local) */
  function wishGet() { try { return JSON.parse(localStorage.getItem('gc-wish') || '[]'); } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem('gc-wish', JSON.stringify(a)); } catch (e) {} }
  $$('[data-wishlist]').forEach(function (b) {
    var id = b.getAttribute('data-id');
    if (wishGet().indexOf(id) > -1) b.setAttribute('aria-pressed', 'true');
    b.addEventListener('click', function () {
      var a = wishGet(), i = a.indexOf(id);
      if (i > -1) { a.splice(i, 1); b.setAttribute('aria-pressed', 'false'); } else { a.push(id); b.setAttribute('aria-pressed', 'true'); }
      wishSet(a);
    });
  });

  /* Description clamp */
  $$('[data-clamp-toggle]').forEach(function (btn) {
    var box = btn.parentNode.querySelector('[data-clamp]');
    if (box && box.scrollHeight <= box.clientHeight + 8) { btn.style.display = 'none'; return; }
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('open'); btn.textContent = open ? 'Read less' : 'Read more';
    });
  });

  /* Header condense on scroll */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Dispatch-cutoff countdown (honest urgency) ---------- */
  (function () {
    var els = $$('[data-dispatch]'); if (!els.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = new Date();
      var cutoff = new Date(); cutoff.setHours(15, 0, 0, 0); // 3pm UK dispatch cutoff, Mon–Fri
      var day = now.getDay();
      var open = day >= 1 && day <= 5 && now < cutoff;
      els.forEach(function (el) {
        var nudge = el.closest('.dispatch-nudge');
        if (open) {
          var diff = cutoff - now;
          var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
          el.textContent = (h > 0 ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's';
        } else if (nudge) {
          var svg = nudge.querySelector('svg');
          nudge.innerHTML = (svg ? svg.outerHTML : '') + ' <span><strong>In stock &amp; ready</strong> — order now for fast UK dispatch</span>';
        }
      });
      if (open) setTimeout(tick, 1000);
    }
    tick();
  })();

  /* ---------- Rotating announcement bar ---------- */
  (function () {
    $$('[data-rotator]').forEach(function (bar) {
      var msgs = $$('.announce-msg', bar);
      if (msgs.length < 2) { if (msgs[0]) { msgs[0].classList.add('is-active'); } return; }
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 3600);
    });
  })();

  /* Reveal on scroll — with a fail-safe so content is NEVER left hidden */
  var reveals = $$('.reveal');
  function revealAll() { reveals.forEach(function (el) { el.classList.add('is-in'); }); }
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -4% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
    // Safety net: if anything hasn't revealed shortly after load, show it anyway.
    window.addEventListener('load', function () { setTimeout(revealAll, 1800); });
  } else { revealAll(); }

  /* Collection sort */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]'); if (!s) return;
    var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
